/* eslint-disable react/no-danger */
/* eslint-disable max-len */
import React from 'react';

export default function Trash(props) {
  return (
    <svg
      className={props.className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 300 300"
      {...props}
    >
      <defs>
        <style
          dangerouslySetInnerHTML={{ __html: `.cls-1{fill:${props.fill ? props.fill : '#999'};}` }}
        />
      </defs>
      <title>Delete</title>
      <g id="Trash">
        <rect className="cls-1" x="85.54" y="132.22" width="16.99" height="126.74" />
        <rect className="cls-1" x="141.51" y="132.22" width="16.99" height="126.74" />
        <rect className="cls-1" x="197.48" y="132.22" width="16.99" height="126.74" />
        <path
          className="cls-1"
          d="M279.92,62.78A14.39,14.39,0,0,0,265.53,48.4h-56V26.17A26.21,26.21,0,0,0,183.38,0H116.62A26.21,26.21,0,0,0,90.44,26.17V48.4h-56A14.39,14.39,0,0,0,20.08,62.78v45.38H34.82V300H265.19V108.16h14.73ZM107.43,26.17a9.21,9.21,0,0,1,9.19-9.2h66.76a9.21,9.21,0,0,1,9.19,9.2V48.4H107.43ZM37.06,65.37H262.94V91.19H37.06ZM248.2,283H51.81V108.16H248.2Z"
        />
      </g>
    </svg>
  );
}
